import Export2Excel from '../excel/Export2Excel.js'

function getExport(header,property,list, name) {
  const data = formatJson(property, list)
  const filename = name + (new Date()).toLocaleDateString();
  Export2Excel.export_json_to_excel({
    header,
    data,
    filename
  })
}


 function formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => {
      return v[j]
    }))
  }

export default {
  getExport
};



// WEBPACK FOOTER //
// ./src/tools/export.js